// extracted by mini-css-extract-plugin
export default {"root":"Particle_root__rUG+b"};